import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

interface ShippingReturnRulesItemProps {
  title?: string
  value: string
}

const ShippingReturnRulesItem: RFC<ShippingReturnRulesItemProps> = ({
  title,
  value
}) => {
  if (!value) return null

  return (
    <Stack spacing={1}>
      {!!title && (
        <Text variant="body2" color="text.third">
          {title}
        </Text>
      )}

      <Text
        variant="body2"
        sx={{ ...(!IS_NATIVE_APP && { wordBreak: 'break-word' }) }}
      >
        {value}
      </Text>
    </Stack>
  )
}

export default ShippingReturnRulesItem
